import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';

import { AppConfigStore } from '@services/store/app-config.store';

export const appConfigGuard: CanActivateFn = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const appConfigStore = inject(AppConfigStore);
  const router = inject(Router);

  if (next.url.length > 0) {
    const entries = Object.entries(appConfigStore.get().allowRoutes);
    const path = next.url[0].path;

    for (const [key, value] of entries) {
      if (key === path) {
        if (!value) {
          router.navigateByUrl('/');
        }
        return value;
      }
    }
  }

  return true;
};
